import React, { useCallback } from 'react';
import ConfirmationModal from '../../../../../components/ConfirmationModal';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { selectModalData } from '../../../../../redux/selectors/modal';
import { closeModal } from '../../../../../redux/slices/modal';

const RemoveDashboardFilterModal = () => {
  const dispatch = useAppDispatch();
  const { dashboardName, onRemove } = useAppSelector(selectModalData);

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  return (
    <ConfirmationModal
      open
      onClose={handleClose}
      onSubmit={onRemove}
      header={'Remove Dashboard Filter'}
      confirmActionLabel={'Remove Filter'}
      trackContext="dashboards"
      trackConfirmAction="remove filter - confirm"
      trackCancelAction="remove filter - cancel"
    >
      Do you want to remove the default filter from{' '}
      <strong>{dashboardName}</strong>? This action cannot be undone.
    </ConfirmationModal>
  );
};

export default RemoveDashboardFilterModal;
